export default __webpack_public_path__ + "static/media/restaurants.fedb2d4a.svg";